import React, {
    FC, useMemo,
} from 'react';

import {ERequestStatus} from 'store/slices/request-slice/request-slice-type';

import {RequestActionTypeResolver} from './request-action-type-resolver';

interface IRequestActionItemProps {
    requestFormKey: string;
    requestCommentId?: string;
    id?: string | number;
    action: ERequestStatus;
    entityName?: string;
    onSubmit?: () => void;
}

export const RequestActionItem: FC<IRequestActionItemProps> = ({
    id,
    action,
    entityName,
    requestFormKey,
    requestCommentId,
    onSubmit,
}: IRequestActionItemProps) => {
    const Component = useMemo(() => RequestActionTypeResolver(
        action,
        requestFormKey,
        requestCommentId,
        entityName,
        onSubmit,
    ),
    [action, id]);
    return (
        <Component key={action} />
    );
};
